import { render, staticRenderFns } from "./DialogUploadResources.vue?vue&type=template&id=a6cd6ffa&scoped=true&"
import script from "./dialog_upload_resources.js?vue&type=script&lang=js&"
export * from "./dialog_upload_resources.js?vue&type=script&lang=js&"
import style0 from "./DialogUploadResources.vue?vue&type=style&index=0&id=a6cd6ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cd6ffa",
  null
  
)

export default component.exports